/**
 * Histórico de acessos (Global)
 */
export default class CPreferenciaCredencialAcessoAPI {
  email: string = '';
  ultimoAcesso: Date = new Date();

  constructor(pObj?: Partial<CPreferenciaCredencialAcessoAPI>) {
    Object.assign(this, pObj);
  }
}
